import { EventBusKey } from "@vueuse/core";
import { AmendmentOptionTypeEnum } from "../enums";
import { BookingCancel } from "../www/BookingCancel";
import { BookingSummary } from "../www/store/BookingSummary";

export const cancelDialogKey: EventBusKey<CancelBooking> = Symbol()

export interface CancelBooking {
    booking: BookingSummary;
    payment: BookingCancel;
    type: AmendmentOptionTypeEnum;
    cancelRoute?: string;
}